module.exports = __webpack_public_path__ + "static/media/Applause.b4039c39.mp3";